import { Reducer } from 'redux';

import { DismissablePromptViewActions, DismissablePromptViewState } from './types';

const initialState: DismissablePromptViewState = {
  currentlyVisiblePromptKey: null,
};

const reducer: Reducer<DismissablePromptViewState, DismissablePromptViewActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'DISMISSABLE_PROMPTS.SET_CURRENTLY_VISIBLE_PROMPT': {
      return {
        ...state,
        currentlyVisiblePromptKey: action.payload.currentlyVisiblePromptKey,
      };
    }
    default:
      return state;
  }
};

export default reducer;
